import { useState } from 'react';
import DropDownItems from './DropDownItems';
import { MenuList } from './styled';
import { useRouter } from 'next/router';
import { fireEvent } from '../../../Utils/fireEvent';

export default function ShopByCategory(props) {
  let {
    categoryData,
    setDrawerOpen,
    initialOrder,
    restoreSideBarValue,
    trackOrderHandler,
  } = props;
  const L1CountShow = restoreSideBarValue ? null : 8;
  const [cardEffect, setCardEffect] = useState({ index: null, class: null });
  const [data, setData] = useState(categoryData);
  const router = useRouter();
  const categoryClickHandler = (category, indexData, parent, l2Parent) => {
    setCardEffect({ index: indexData, class: 'lowOpacity' });
    document.documentElement.classList.add('normal-scroll');
    fireEvent({
      category: 'clicked_sidedrawer_item',
      screen_name: 'STORE_HOME',
      // section: categoryData[indexData]?.tabName,
      parent:
        category?.tabName == 'हिन्दी' || category?.tabName == 'বাঙ্গালী'
          ? 'language'
          : category?.tabName,
      item_name:
        category?.tabName == 'हिन्दी'
          ? 'hindi'
          : category?.tabName == 'বাঙ্গালী'
            ? 'bangla'
            : category?.tabName,
      parent:
        category?.tabName == 'हिन्दी' || category?.tabName == 'বাঙ্গালী'
          ? 'language'
          : parent
            ? parent
            : 'NA',
      parent_l2: l2Parent ? l2Parent : 'NA',
    });
    setTimeout(() => setDrawerOpen(false), 500);
  };
  const getCategoryL1 = (categoryData) => {
    let obj = {
      tabName: `All products in ${categoryData?.tabName}`,
      webUrl: categoryData?.webUrl || categoryData?.key,
      key: categoryData?.key || categoryData?.webUrl,
    };
    return obj;
  };
  const morphCategoryData = (data, level, returnData) => {
    data?.map((category) => {
      if (level == 1) {
        const obj = getCategoryL1(category);
        const categoryNameLC =
          category?.subCategories?.[0]?.tabName?.toLowerCase();
        const isL2CategoryWithL3 = categoryNameLC?.includes('concern')
          ? 0
          : categoryNameLC?.includes('ingredient')
            ? 1
            : null;
        if (typeof isL2CategoryWithL3 == 'number') {
          category['subCategories'] = [
            obj,
            ...category?.subCategories[isL2CategoryWithL3]?.subCategories,
          ];
        } else {
          category['subCategories'] = [obj, ...category?.subCategories];
        }
      } else {
        returnData = morphCategoryData(
          category?.subCategories,
          level + 1,
          returnData,
        );
      }
    });

    return data;
  };
  // useEffect(() => {
  //     const categoryDataMorphed = morphCategoryData(categoryData, 0, []);
  //     setData(categoryDataMorphed);
  // }, [categoryData]);
  return (
    <>
      <MenuList>
        {data?.map((category, index) => {
          if (index == 1) {
            category['image'] =
              'https://images.myloapp.in/NestJsUploads/1697875324901-mylo-care-1-line-logo.webp';
          } else if (index == 2) {
            category['image'] =
              'https://images.myloapp.in/NestJsUploads/1697875324904-mylo-baby-1-line-logo.webp';
          }
          const copyOrder = [...initialOrder];
          if (!restoreSideBarValue) copyOrder[0] = index;
          return (
            <>
              <DropDownItems
                key={`dropDownItems${index}`}
                category={category}
                index={index}
                categoryClickHandler={categoryClickHandler}
                setDrawerOpen={setDrawerOpen}
                childlevel={0}
                cardEffect={cardEffect}
                baseId={index}
                initialOrder={copyOrder}
                countShow={L1CountShow}
                trackOrderHandler={trackOrderHandler}
              />
              {/* {index == 0 ? (
                                <L0BottomSpan />
                            ) : index == 1 ? (
                                <L0BottomSpan showMargin={true} />
                            ) : null} */}
            </>
          );
        })}

        {/* <ExtraHeight></ExtraHeight> */}
      </MenuList>
    </>
  );
}
